import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getMarcas() {
    return axios.get(`${API_URL}/marcas`, { headers: authHeader() });
  },
  createData(data) {
    return axios.post(`${API_URL}/marcas`, data, { headers: authHeader() });
  },
  updateData(id, data) {
    return axios.put(`${API_URL}/marcas/${id}`, data, { headers: authHeader() });
  },
  deleteData(id) {
    return axios.delete(`${API_URL}/marcas/${id}`, { headers: authHeader() });
  },
};
